enum Label {
    NONE = 'NONE',
    ENGLISH = 'English',
    JAPANESE = '日本語',
    GERMAN = 'Deutsche',
    ITALIAN = 'Italiano',
    FRENCH = 'Français',
    SPANISH = 'Español'
}

export default Label;